module.exports = __webpack_public_path__ + "static/media/guest_list.c5da0b59.svg";